import { render } from "./MultiplicitySelector.vue?vue&type=template&id=8f901ef0"
import script from "./MultiplicitySelector.vue?vue&type=script&lang=js"
export * from "./MultiplicitySelector.vue?vue&type=script&lang=js"

import "./MultiplicitySelector.vue?vue&type=style&index=0&id=8f901ef0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__